import React from 'react';
import {Sticky, StickyContainer} from "react-sticky";
import {Card, Col, Row, Button} from "react-bootstrap";
import AutoSave from "./AutoSave";
import {useSelector, useDispatch} from "react-redux";
import TextField from "../base_components/TextField";
import DateField from "../base_components/DateField";
import ConfirmDeleteModal from "./ConfirmDeleteModal";
import AffiliateMemberTabs from "./AffiliateMemberTabs";
import SelectField from "../base_components/SelectField";
import GeneralAffiliateMemberFormModal from "../modals/GeneralAffiliateMemberFormModal";
import ContactFormModal from "../modals/ContactFormModal";
import SaveButton from "./SaveButton";
import BooleanField from "../base_components/BooleanField";
import ModalButton from './ModalButton';
import { useState } from "react";
import ErrorModal from '../ErrorModal';


const AffiliateMemberDetailsForm = () => {
  const dispatch = useDispatch();
  const { affiliateMember, affiliateMemberDetail, affiliateMemberAddress, stateOptions, statusesOptions, affiliateMemberContacts, organization, ui } = useSelector((state) => state);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const handleEditContact = (contact) => {

    dispatch({
      type: 'CLOSE_RESOURCE_MODAL',
      payload: { resourceName: 'contact' }
    });

    dispatch({
      type: 'EDIT_RESOURCE',
      payload: {
        resourceName: 'contact',
        resource: contact
      }
    });
  };

  return (
    <StickyContainer>
      <ErrorModal/>
      <ConfirmDeleteModal
        show={confirmDelete}
        handleHide={() => setConfirmDelete(false)}
        organization={organization}
        affiliateMember={affiliateMember}
      />
      <Card>
        <Sticky>
          {({style}) => {
            return (
              <Card.Header
                style={{...style, zIndex: 10}}
                className="d-md-flex justify-content-between align-items-center"
              >
                <div>{`${affiliateMemberDetail.organization_name}`}</div>
                <div>
                <span>
                  <span style={{ fontSize: 14 }}>Last updated on </span>
                  <span style={{fontSize: 14 }}>{ui.member_updated_at ? moment(ui.member_updated_at).format("llll") : moment(affiliateMember.updated_at).format("llll")}</span>
                </span>
                </div>
                <div className="d-lg-flex justify-content-center align-items-center">
                  <div className="mt-2">
                    <SaveButton />
                  </div>
                </div>
              </Card.Header>
            );
          }}
        </Sticky>
        <div className="card-block">
          <Row>
            <Col md={12}>
              <GeneralAffiliateMemberFormModal
                stateOptions={stateOptions}
                statusesOptions={statusesOptions}
              />
              <Row>
                <TextField name="organization_name" label="Name of Organization" action="show" col="2"/>
                <TextField name="website" label="Website" action="show" col="2"/>
                <TextField name="name" label="Contact Name" action="show" resource={"affiliateMember"} col="2"/>
                <TextField name="email" label="Contact Email" action="show" col="2"/>
                <TextField name="phone_number" label="Primary Phone Number" action="show" col="2"/>
                <TextField name="street" label="Street Address" action="show" resource={"affiliateMemberAddress"} col="2"/>
                <TextField name="city" label="City" action="show" resource={"affiliateMemberAddress"} col="2"/>
                <TextField name="state" label="State" action="show" resource={"affiliateMemberAddress"} col="2"/>
                <TextField name="zipcode" label="Zipcode" action="show" resource={"affiliateMemberAddress"} col="2"/>
                <DateField name="linked_at" label="Join Date" action="show" resource={"affiliateMember"} col="2"/>
                <TextField name="provider_id" label="Provider ID" action="show" resource={"affiliateMemberDetail"} col="2"/>
                <TextField name="legal_entity_name" label="Legal Entity Name" action="show" resource={"affiliateMemberDetail"} col="2"/>
                <TextField name="types_of_organizations" label="Type of Organization" action="show" resource={"affiliateMemberDetail"} col="2"/>
                <TextField name="crra" label="CRRA" action="show" resource={"affiliateMemberDetail"} col="2"/>
                <TextField name="billing_address" label="Company Billing Address" action="show" resource={"affiliateMemberDetail"} col="2"/>
                <TextField name="number_of_residences" label="Number of Residences" action="show" resource={"affiliateMemberDetail"} col="2"/>
                <BooleanField name="healthcare_ownership" label="Healthcare Ownership" action="show" resource={"affiliateMemberDetail"} col="2"/>
                <BooleanField name="scholarship" label="Scholarship" action="show" resource={"affiliateMemberDetail"} col="2"/>
                <BooleanField name="certified_residence_requirements" label="Certified Residence Requirements" action="show" resource={"affiliateMemberDetail"} col="2"/>
                <BooleanField name="narr_agreement" label="NARR Agreement" action="show" resource={"affiliateMemberDetail"} col="2"/>
                <BooleanField name="lab_ownership" label="Lab Ownership" action="show" resource={"affiliateMemberDetail"} col="2"/>
                <TextField name="statuses" label="Status" action="show" resource={"affiliateMemberDetail"} col="6"/>
                <TextField name="business_entity_name" label="Name of Business Entity" action="show" resource={"affiliateMemberDetail"} col="2"/>
                <DateField name="join_date" label="Join Date" action="show" resource={"affiliateMemberDetail"} col="2"/>
              </Row>
              <div className="d-flex justify-content-center mb-3">
                <ModalButton
                  resourceName="general"
                  label="Add/Edit General Details"
                />
              </div>
              <Row className="mt-4">
                <Col md={12}>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">Contacts</h5>
                    {ui.action === "edit" && (
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => {
                          dispatch({
                            type: 'NEW_RESOURCE',
                            payload: { resourceName: 'contact' }
                          });
                        }}
                      >
                        <i className="fas fa-plus mr-1"></i> Add Contact
                      </Button>
                    )}
                  </div>
                  <ContactFormModal
                    affiliateMember={affiliateMember}
                    affiliateMemberDetail={affiliateMemberDetail}
                    organization={organization}
                  />
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Title</th>
                        <th>Email</th>
                        <th>Phone Number</th>
                        <th>Credentials</th>
                        {ui.action === "edit" && <th>Actions</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {affiliateMemberContacts?.map((contact, index) => (
                        <tr key={contact.id || index}>
                          <td>{contact.name}</td>
                          <td>{contact.title}</td>
                          <td>{contact.email}</td>
                          <td>{contact.phone}</td>
                          <td>{contact.credentials}</td>
                          {ui.action === "edit" && (
                            <td>
                              <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => handleEditContact(contact)}
                              >
                                Edit
                              </Button>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Card>
      <AffiliateMemberTabs/>
      {ui.action === "edit" && (<>
        <Card className="card-outline-danger">
          <Card.Header className={"d-flex justify-content-between"}>
            Delete Member
            <Button
              variant="danger"
              onClick={() => setConfirmDelete(true)}
            >
              Delete Member
            </Button>
          </Card.Header>
          <Card.Body className="card-block">
            <p>Do this only if you are sure</p>
          </Card.Body>
        </Card>
      </>)}
    </StickyContainer>)
}

export default AffiliateMemberDetailsForm;
